import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

const module = angular.module('desktop-coverage-policy-card', []);

module.component('desktopCoveragePolicyCard', {
    template: template,
    bindings: {
        policyNumber: '<',
        policyRenewalDate: '<',
        policyAutoRenewal: '<',
        policyEffectiveDateRange: '<'
    },
    controller: function() {}
});

export { module };
